import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ThumbDownFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.88 15.78C5.48 15.78 4.42 14.54 4.66 13.16L5.68 8.44C5.86 7.36 6.68 4.6 10.18 4.6H19.2V13.56C16.2 13.92 14.46 16.2 14.46 18.6V19.66C14.46 20.6 13.7 21.36 12.76 21.36C11.82 21.36 11.06 20.6 11.06 19.66V15.78H6.88Z" />
    </SvgIcon>
  );
});
